"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _card_component = require("./global_components/card_component");

var _card_component2 = _interopRequireDefault(_card_component);

var _reactIntl = require("react-intl");

var _calendar_year_performance_returns_bar_chart = require("./charts/calendar_year_performance_returns_bar_chart");

var _calendar_year_performance_returns_bar_chart2 = _interopRequireDefault(_calendar_year_performance_returns_bar_chart);

var _functional_utility = require("../../../packages/common-utilities/src/functional_utility");

var _date_formatter = require("../../../packages/common-utilities/src/date_formatter");

var _date_formatter2 = _interopRequireDefault(_date_formatter);

var _sanitize_utility = require("../../../packages/common-utilities/src/sanitize_utility");

var _sanitize_utility2 = _interopRequireDefault(_sanitize_utility);

var _string_utility = require("../../../packages/common-utilities/src/string_utility");

var _string_utility2 = _interopRequireDefault(_string_utility);

var _collection_utility = require("../../../packages/common-utilities/src/collection_utility");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CalendarYearPerformanceCard = function (_React$PureComponent) {
  _inherits(CalendarYearPerformanceCard, _React$PureComponent);

  function CalendarYearPerformanceCard() {
    _classCallCheck(this, CalendarYearPerformanceCard);

    return _possibleConstructorReturn(this, (CalendarYearPerformanceCard.__proto__ || Object.getPrototypeOf(CalendarYearPerformanceCard)).apply(this, arguments));
  }

  _createClass(CalendarYearPerformanceCard, [{
    key: "render",
    value: function render() {
      var historicalCalendarYearPerformanceReturn = this.props.historicalData.historicalCalendarYearPerformanceReturn;


      var isLessThan1CalendarYear = (0, _functional_utility.isNilOrEmpty)(historicalCalendarYearPerformanceReturn) || (0, _functional_utility.isNilOrEmpty)(historicalCalendarYearPerformanceReturn.performanceData);
      var fiveYear = _date_formatter2.default.getCalendarYears(this.props.shareclass.shareClassInceptionDate) <= 5;
      var shareClassInceptionDate = _react2.default.createElement(
        "span",
        { className: "white-space-default" },
        _string_utility2.default.renderFormattedLabel("Share class since inception:", "pdp-shareclass-inception-date-performance-bar-chart", { role: this.props.role }),
        " ",
        _date_formatter2.default.getDateInDDMMYYYSlashFormat(this.props.shareclass.shareClassInceptionDate)
      );
      var showShareclassInceptionDate = _collection_utility.CollectionUtility.includes((this.props.visibleData || {}).visibleCharts, 'SHARECLASS_INCEPTION_DATE');

      return _react2.default.createElement(
        _card_component2.default,
        {
          dataTest: "calendar-year-performance-card",
          className: "print-full-width",
          headerTitle: _react2.default.createElement(_reactIntl.FormattedMessage, { id: "pdp-calendar-year-performance-label",
            defaultMessage: "Calendar year performance" }),
          headerTitleId: "calendar-year-performance-header",
          headerTitleLabel: "",
          headerLabel: "",
          displayStyle: 'width-percent-100',
          breakpoint: this.props.breakpoint
        },
        !isLessThan1CalendarYear && _react2.default.createElement(
          "div",
          null,
          showShareclassInceptionDate && _react2.default.createElement(
            "span",
            { "data-testid": "performance-chart-shareclass-inception-date", className: "font-regular tag" },
            shareClassInceptionDate,
            _react2.default.createElement("br", null)
          ),
          _react2.default.createElement("span", { className: "body-bold", dangerouslySetInnerHTML: { __html: _sanitize_utility2.default.runSanitizer(this.props.topOfCardDisclosure) } }),
          _react2.default.createElement(_calendar_year_performance_returns_bar_chart2.default, { historicalCalendarYearPerformanceReturn: historicalCalendarYearPerformanceReturn,
            gaiaRedirectUrl: this.props.gaiaRedirectUrl,
            visibleData: this.props.visibleData,
            fundShareclassEvents: this.props.shareclass.fundShareclassEvents,
            shareclassName: this.props.shareclass.name, numberFormat: this.props.numberFormat, fiveYear: fiveYear, hoverState: true
          }),
          _react2.default.createElement("span", { className: "disclaimer2", dangerouslySetInnerHTML: { __html: _sanitize_utility2.default.runSanitizer(this.props.bottomOfCardDisclosure) } }),
          _react2.default.createElement("br", null),
          _react2.default.createElement("span", { className: "disclaimer", dangerouslySetInnerHTML: { __html: _sanitize_utility2.default.runSanitizer(this.props.footnoteOfCardDisclosure) } })
        ),
        isLessThan1CalendarYear && _react2.default.createElement(
          "div",
          null,
          _react2.default.createElement("span", { dangerouslySetInnerHTML: { __html: _sanitize_utility2.default.runSanitizer(this.props.lessThan1YrDisclosure) } })
        )
      );
    }
  }]);

  return CalendarYearPerformanceCard;
}(_react2.default.PureComponent);

exports.default = CalendarYearPerformanceCard;